import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Contact from '../components/Contact/Contact'
import Footer from '../components/Footer/Footer'

const Contactpage = () => {
    return (
        <div>
        <Navbar/>
        <Contact/>
        <Footer/>

        </div>
    )
}

export default Contactpage